import { Component } from 'ng-metadata/core';
import './status-bar.scss';

/**
 * @ngdoc directive
 * @name mwContentStreamStatusBar
 * @module mw.components.contentStream
 * @description
 * `<mw-content-stream-status-bar>` is a used for displaying information such as sort status in the `<mw-content-stream-header>`, multiple 
 * status items are separated by a dot.
 * @usage
 * <hljs hljs-language="html">
 *    <mw-content-stream-status-bar>
 *       <mw-content-stream-status-item>
 *           Sorted by {{$ctrl.sortBy}}
 *       </mw-content-stream-status-item>
 *       <mw-content-stream-status-item>
 *           {{$ctrl.sortOrder}} first
 *       </mw-content-stream-status-item>
 *   </mw-content-stream-status-bar>
 * </hljs>
 */

@Component({
    selector: 'mw-content-stream-status-bar',
    template: `
        <div class="mw-content-stream-status-bar">
            <ng-transclude></ng-transclude>
        </div>
    `,
    legacy: {
        transclude: true
    }
})
export class StatusBarComponent {

    constructor() {
    }

}



// WEBPACK FOOTER //
// ./src/lib/components/content-stream/status-bar/status-bar.component.ts